import React from 'react';

const PopupInfoFormModal = React.lazy(() => import('../components/FormModal'));
const popupInfoModalRegistry = {
    crm_popupInfoId: PopupInfoFormModal
};
export default popupInfoModalRegistry;
